import {store} from '../../redux/store';
import {showToast, hideToast} from './reducer';
import {ToastMessage} from '../../interfaces/connected-components/toast';

/**
 * Shows a global modal toast with the specified message.
 *
 * @param {ToastProps} toastMessage - The toast message props.
 * @returns {void}
 */
export const showGlobalToast = (toastMessage: ToastMessage): void => {
  store.dispatch(showToast(toastMessage));
};

/**
 * Closes the global modal toast.
 *
 * @returns {void}
 */
export const closeGlobalToast = (): void => {
  store.dispatch(hideToast());
};
